<template>
  <div class="cloudtopdetails">
    <div id="header-bar"></div>
    <h1 id="header"> {{headline.title}}</h1>
    <p id="date">{{headline.date}}</p>
    <!-- 以下是传回来的html的code -->
    <div>{{headline.abst}}</div>
    <div>
      <img :src="headline.img">
    </div>
    <div style="padding: 10px;" v-html="headline.content"></div>
  </div>
</template>

<script>
  import request from '../utils/request.js'
  import Qs from 'qs'
  export default {
    name: 'cloudtopdetails',
    data() {
      return {
        msg: '',
        lang: 1,
        ID: 1,
        headline: {}
      }
    },
    created() {
      this.ID = this.$route.query.headline_id;
      if (this.$route.query.lang) {
        this.lang = this.$route.query.lang;
      }
      console.log('ID:' + this.ID + ' lang:' + this.lang);
      this.$axios({
        url: '/myyd/public/headline_detail',
        method: 'post',
        header: {
          'content-type': 'application/x-www-form-urlencoded'
        },
        data: Qs.stringify({
          headline_id: this.ID,
          lang: this.lang
        })
      }).then(res => {
        console.log(res);
        this.headline = res.data.data.headline_list;
      });
    },
    mounted() {
      this.adptStatusBar()
    },
    methods: {
      adptStatusBar() {
        console.log(window.screen.height, window.outerHeight)
        let statusBarHeight = window.screen.height - window.outerHeight
        console.log('状态栏高度：', statusBarHeight)
        let u = navigator.userAgent
        let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
        if (isAndroid) {
          console.log('安卓环境')
          let headerEle = document.getElementById('header-bar')
          headerEle.style.cssText = `margin-top: ${statusBarHeight} px ;`;
        }
      }
    }
  }
</script>>

<style scoped>
  #header {
    text-align: center;
    font-size: 19px;
  }

  #date {
    text-align: center;
    font-size: 14px;
    margin: 0 0 8px 0;
    font-family: PingFang SC;
    font-weight: 400;
    color: #000000;
    opacity: 0.5;
  }

  p {
    width: 100%;
    text-align: justify;
    margin: 0px 0px 0px -7px;
    /* text-indent:2em; */
  }

  img {
    width: 100%;
    height: 100%;
  }

  #header-bar {
    height: 44px;
    width: 100vw;
    position: sticky;
    background-color: #fff;
    top: 0;
    z-index: 999;
  }

  @supports ((height: constant(safe-area-inset-top)) or (height: env(safe-area-inset-top))) and (-webkit-overflow-scrolling: touch) {
    #header-bar {
      margin-top: constant(safe-area-inset-top);
      margin-top: env(safe-area-inset-top);
    }
  }
</style>>



// WEBPACK FOOTER //
// src/components/CloudTopDetails.vue